var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#208ce1;stroke:#208ce1;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 55,
    height: 55,
    transform: "translate(321 1222)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-321 -1222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.5 1220.885)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M54.2,5.5H2.425a.916.916,0,0,0-.925.925V39.008a.916.916,0,0,0,.925.925H21.693l-1.073,5.344H13.853A4.956,4.956,0,0,0,8.9,50.232v.573a.916.916,0,0,0,.925.925H46.806a.916.916,0,0,0,.925-.925v-.573a4.956,4.956,0,0,0-4.956-4.956H36.006l-1.073-5.344H54.2a.916.916,0,0,0,.925-.925V6.425A.916.916,0,0,0,54.2,5.5Zm-8.34,44.381h-35.1a3.1,3.1,0,0,1,3.088-2.755H42.774A3.118,3.118,0,0,1,45.862,49.881Zm-23.355-4.6,1.017-5.085H33.1l1.017,5.085ZM53.278,7.349V32.313H3.349V7.349ZM3.349,38.083v-3.92H53.278v3.92H3.349Z",
    transform: "translate(0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.6da334a2a7fd35ffa80acdf93803caf7.svg";
export { ForwardRef as ReactComponent };